import ax from "../../shared/utils/http_client"
import { currencyHelper } from "../utils/currency"

export const CouponManager = [() => ({
  couponCode: '',
  appliedCoupon: null,
  discountAmount: 0,
  couponDiscountType: '',
  isValidating: false,
  errorMessage: '',
  successMessage: '',
  currencySymbol: 'NT$',
  currencyCode: 'TWD',

  async init() {
    const { currencyCode, currencySymbol } = await currencyHelper.loadCurrencyInfo()
    this.currencyCode = currencyCode
    this.currencySymbol = currencySymbol

    this.$watch('$store.frontend.cart', () => {
      if (this.hasAppliedCoupon) {
        this.checkCouponStillValid()
      }
    })
    // 同步更新免運券的折扣金額
    window.addEventListener('coupon-discount-changed', (e) => {
      this.discountAmount = e.detail.value;
    });
  },
  // 這部分目前有bug，之後有時間可再修
  async loadAppliedCoupon() {
    try {
      const response = await ax.get('/api/v1/cart')
      const appliedCoupon = response.data.cart.appliedCoupon

      if (appliedCoupon) {
        this.appliedCoupon = appliedCoupon
        this.discountAmount = appliedCoupon.discountAmount
        this.couponDiscountType = appliedCoupon.discount_type
        document.getElementById('order_coupon_id').value = appliedCoupon.id

        this.$dispatch('coupon-applied', {
          coupon: appliedCoupon,
          discountAmount: appliedCoupon.discountAmount
        })
      }
    } catch (error) {
      console.error('載入已套用折價券失敗:', error)
    }
  },

  async checkCouponStillValid() {
    if (!this.hasAppliedCoupon) return

    try {
      const response = await ax.post('/api/v1/coupons/validate', {
        code: this.appliedCoupon.code
      })

      if (!response.data.success) {
        await this.removeCoupon()
        this.showError('折價券已不適用於目前選擇的商品，已自動移除')
      } else {
        const newDiscountAmount = response.data.coupon.discount_amount
        if (newDiscountAmount !== this.discountAmount) {
          this.discountAmount = newDiscountAmount
          this.$dispatch('coupon-applied', {
            coupon: this.appliedCoupon,
            discountAmount: this.discountAmount
          })
        }
      }
    } catch (error) {
      await this.removeCoupon()
      this.showError('折價券驗證失敗，已自動移除')
    }
  },

  async validateCoupon() {
    if (!this.couponCode.trim()) {
      this.showError('請輸入折價券代碼')
      return
    }

    this.isValidating = true
    this.clearMessages()

    try {
      const response = await ax.post('/api/v1/coupons/validate', {
        code: this.couponCode.trim()
      })

      if (response.data.success) {
        // 驗證成功，不顯示訊息，讓 applyCoupon 處理最終結果
        return response.data.coupon
      } else {
        this.showError(response.data.message)
        return null
      }
    } catch (error) {
      let message = '驗證失敗，請稍後再試'

      if (error.response?.data?.message) {
        message = error.response.data.message
      } else if (error.response?.status === 404) {
        message = '折價券代碼不存在'
      } else if (error.response?.status === 422) {
        message = '折價券無法使用'
      }

      this.showError(message)
      return null
    } finally {
      this.isValidating = false
    }
  },

  async applyCoupon() {
    this.clearMessages()

    const couponData = await this.validateCoupon()

    if (!couponData) {
      return
    }

    try {
      const { data } = await ax.post('/api/v1/coupons/apply', {
        code: this.couponCode.trim()
      })

      if (data.success) {
        this.appliedCoupon = couponData
        this.discountAmount = data.discount_amount
        this.couponDiscountType = couponData.discount_type
        this.couponCode = ''
        document.getElementById('order_coupon_id').value = couponData.id

        this.showSuccess(`折價券已成功套用！可折抵 ${this.formatPrice(data.discount_amount)}`)

        this.$store.frontend.setCart(data.cart)

        // 觸發折價券套用事件，傳遞正確的折扣金額
        this.$dispatch('coupon-applied', {
          coupon: couponData,
          discountAmount: data.discount_amount
        })
      } else {
        this.showError(data.message)
      }
    } catch (error) {
      let message = '應用失敗，請稍後再試'

      if (error.response?.data?.message) {
        message = error.response.data.message
      } else if (error.response?.status === 404) {
        message = '查無此折價券'
      } else if (error.response?.status === 422) {
        message = '折價券無法使用'
      }

      this.showError(message)
    }
  },

  async removeCoupon() {
    try {
      const response = await ax.delete('/api/v1/coupons/remove')

      if (response.data.success) {
        this.appliedCoupon = null
        this.discountAmount = 0
        this.couponDiscountType = ''
        document.getElementById('order_coupon_id').value = ''
        this.showSuccess('已移除折價券')

        this.$store.frontend.setCart(response.data.cart)

        this.$dispatch('coupon-removed')
      } else {
        this.showError(response.data.message)
      }
    } catch (error) {
      const message = error.response?.data?.message || '移除失敗，請稍後再試'
      this.showError(message)
    }
  },

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.applyCoupon()
    }
  },

  showError(message) {
    this.errorMessage = message
    this.successMessage = ''

    setTimeout(() => {
      this.errorMessage = ''
    }, 3000)
  },

  showSuccess(message) {
    this.successMessage = message
    this.errorMessage = ''

    setTimeout(() => {
      this.successMessage = ''
    }, 3000)
  },

  clearMessages() {
    this.errorMessage = ''
    this.successMessage = ''
  },

  formatCouponCode() {
    this.couponCode = this.couponCode.toUpperCase()
  },

  get finalAmount() {
    const cartTotal = this.$store.frontend.cart?.total_selected_amount || 0
    return Math.max(0, cartTotal - this.discountAmount)
  },

  get hasAppliedCoupon() {
    return this.appliedCoupon !== null
  },

  get couponDisplayName() {
    return this.appliedCoupon?.name || this.appliedCoupon?.code || ''
  },

  get appliedCouponCode() {
    return this.appliedCoupon?.code || ''
  },

  formatPrice(amount) {
    const numericAmount = Number(amount || 0)
    const convertedAmount = currencyHelper.convertPrice(numericAmount, 'TWD', this.currencyCode)
    const precision = currencyHelper.getCurrencyPrecision(this.currencyCode)

    const formattedValue = Number(convertedAmount || 0).toLocaleString(undefined, {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision
    })

    return `${this.currencySymbol} ${formattedValue}`.trim()
  },

}), "coupon_manager"]
